/**
 * @Date: 2020-05-26 15:31
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import S from 'ant-design-vue/es/select'
import { isPromise } from '../../../utils/utils'
import { getDefaultProps } from '../../_utils'

const BSelect = {
  name: 'BSelect',
  props: Object.assign({}, S.props, {
    loadOptions: {
      type: Array | Promise,
      required: true
    },
    optionKey: {
      type: String,
      default: 'id'
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    keyValue: {
      type: Boolean,
      default: false
    },
    keyValueSplit: {
      type: String,
      default: '-'
    }
  }),
  model: {
    prop: 'value',
    event: 'change'
  },
  data: () => ({
    optionList: []
  }),
  created () {
    this.loadData()
  },
  watch: {
    loadOptions: {
      handler (c, n) {
        this.loadData()
      }
    },
    immediate: true
  },
  methods: {
    loadData () {
      if (isPromise(this.loadOptions)) {
        this.loadOptions.then(({ data }) => {
          this.optionList = data
        })
      } else {
        this.optionList = this.loadOptions
      }
    },
    renderOptions () {
      const { optionList } = this
      const { optionKey, optionValue, keyValue, keyValueSplit } = this
      return (
        optionList.map(item => {
          const key = item[optionKey]
          const value = item[optionValue]
          const title = keyValue ? `${key} ${keyValueSplit} ${value}` : `${value}`
          return (
            !keyValue ? (
              <a-select-option key={key} title={value} value={key}>{value}</a-select-option>
            ) : (
              <a-select-option key={key} title={title} value={key}>{key} {keyValueSplit} {value}</a-select-option>
            )
          )
        })
      )
    }
  },
  render () {
    // props
    const props = getDefaultProps(S.props, this)
    // listeners
    const options = this.renderOptions()
    return (
      <a-select {...{ props }} {...{ on: this.$listeners }} value={this.model}>
        {options}
      </a-select>
    )
  }
}

export default BSelect
